import React, {useMemo, useState} from 'react';
import {DropdownControl} from '@zvne/fe-framework/dist/presentation/map/controls/dropdown-control';
import {CheckboxDropdownItem} from '@zvne/fe-framework/dist/presentation/form/input/checkbox-dropdown-item';
import {useStrings} from '@zvne/fe-framework/dist/presentation/language/strings';
import {configuration} from '../../../../config/configuration';
import {Layer, Source} from 'react-mapbox-gl';
import {RasterSource} from 'mapbox-gl';
import {strings} from './strings';

interface InfrastructureLayer {
    name: string;
    id: string;
}

export function InfrastructureLayers() {
    const s = useStrings(strings);

    const layers = useMemo<InfrastructureLayer[]>(() => [
        {
            id: 'az110',
            name: `${s.alarmZones} 110 kV`
        },
        {
            id: 'az220',
            name: `${s.alarmZones} 220 kV`
        },
        {
            id: 'az400',
            name: `${s.alarmZones} 400 kV`
        },
        {
            id: 'azOthers',
            name: `${s.alarmZones} ${s.others}`
        },
        {
            id: 'line110',
            name: `${s.lines} 110 kV`
        },
        {
            id: 'line220',
            name: `${s.lines} 220 kV`
        },
        {
            id: 'line400',
            name: `${s.lines} 400 kV`
        },
        {
            id: 'lineOthers',
            name: `${s.lines} ${s.others}`
        },
        {
            id: 'stations',
            name: s.stations
        }
    ], [s]);

    const [selectedLayers, setSelectedLayers] = useState(layers.map(() => false));
    const isLayerSelected = (index: number) => {
        return selectedLayers[index];
    };
    const setLayerSelected = (index: number, isSelected: boolean) => {
        const newArray = [...selectedLayers];
        newArray[index] = isSelected;
        setSelectedLayers(newArray);
    };

    const enabledLayers = useMemo<InfrastructureLayer[]>(() => {
        return layers.filter((_, i) => selectedLayers[i]);
    }, [layers, selectedLayers]);

    const layerJsonSource = useMemo<RasterSource>(() => ({
        type: 'raster',
        tiles: [
            configuration.geoserverRoot +
            '?bbox={bbox-epsg-3857}' +
            '&format=image/png' +
            '&service=WMS' +
            '&version=1.1.1' +
            '&request=GetMap' +
            '&srs=EPSG:3857' +
            '&transparent=true' +
            '&width=256' +
            '&height=256' +
            '&layers=' + enabledLayers.map(l => `${configuration.geoserverLayerPrefix}:${l.id}`).join(',')
        ],
        tileSize: 256
    }), [enabledLayers]);

    return (
        <>
            <DropdownControl id={'layers'} title={s.infrastructure} order={0}>
                {layers.map((layer, index) =>
                    <CheckboxDropdownItem
                        key={layer.id}
                        eventKey={`infrastructure-layer-${layer.id}`}
                        value={isLayerSelected(index)}
                        onChange={checked => setLayerSelected(index, checked)}
                    >
                        {layer.name}
                    </CheckboxDropdownItem>
                )}
            </DropdownControl>
            <Source
                id={'infrastructure-source'}
                tileJsonSource={layerJsonSource}
            />
            <Layer
                type={'raster'}
                id={'infrastructure-layer'}
                sourceId={'infrastructure-source'}
                layout={{
                    'visibility': enabledLayers.length > 0 ? 'visible' : 'none'
                }}
            />
        </>
    );
}
